export const environment = {
  production: true,
  desarrollo: false,
  apiUrl: 'https://api.allasrepuestos.com',
  apiVersion: 'v1',
  endpoints: {
    validateEmailInUse: '/auth/validate-email-in-use',
    login: '/auth/login',
    socialLogin: '/auth/social-login',
    generateOtp: '/auth/otp/generate',
    verifyOtp: '/auth/otp/verify',
    register: '/auth/register',
    seoContent: '/grupos/contenido/seo',
    categorias: {
      subcategoriasDestacados: '/grupos/destacados',
      productosDestacados: '/grupos/productos',
    },
    stores: {
      get: '/stores',
    },
    vehicles: {
      getAll: '/vehicles',
      getAllBrands: '/vehicles/marcas',
      getAllModels: '/vehicles/modelos',
      getModelosAnios: '/vehicles/modelos/anios',
    },
    products: {
      verifyProductFitsVehicle: '/productos/verify-compatibility',
      getAll: '/productos',
      getBySku: '/productos/one',
      getBySkus: '/productos/multiple',
      getTopMarcas: '/productos/marcas',
    },
  },
  verificationType: {
    LOGIN_CON_EMAIL: 1,
    LOGIN_CON_TELEFONO: 2,
    CREAR_CUENTA: 3,
    CAMBIO_EMAIL: 4,
    // Tipos adicionales que ya tenías
    OTP_SMS: 8,
    OTP_EMAIL: 9,
    REGISTER_PHONE: 10,
  },
  registerData: {
    idProveedor: 1,
    modoRegistro: 2,
    prefijoTelefono: '+504',
    idToken: '123456',
    idUsuarioProveedor: '1223456',
  },
  // Configuración de Firebase
  firebaseConfig: {
    apiKey: 'AIzaSyBjzH1A5C3E9-UuV-GS-jI1TxoHpx5cWqo',
    authDomain: 'app-membresia-lealtad-2a6c0.firebaseapp.com',
    projectId: 'app-membresia-lealtad-2a6c0',
    storageBucket: 'app-membresia-lealtad-2a6c0.firebasestorage.app',
    messagingSenderId: '1014375655063',
    appId: '1:1014375655063:web:6be94de035e572de17ebd2',
  },
  // Configuración de Google OAuth
  googleOAuth: {
    clientId:
      '860324226925-h5p7ma0r3s7mt3h2paa8pl1bodig9dg1.apps.googleusercontent.com',
    scope: 'email profile', // Permisos que solicitas: email y perfil del usuario
    // Opciones adicionales que puedes configurar si las necesitas:
    // hosted_domain: 'tudominio.com', // Limitar login a un dominio específico
    // prompt: 'select_account', // Forzar selección de cuenta
  },
  // Configuración de Facebook OAuth
  facebookOAuth: {
    appId: '1334925468168698', // App ID de Facebook
    version: 'v18.0', // Versión de la API de Facebook
    scope: 'email,public_profile', // Permisos que solicitas: email y perfil público
  },
  // Configuración de Microsoft OAuth
  microsoftOAuth: {
    clientId: '1fb71fa8-6089-4f8b-b0c5-a5c72c24fb03', // Application (client) ID de Azure
    clientSecret: 'xwD8Q~q1LMblWHO1qsZmAd_eQnbkMDTvupjjAaI0', // Client Secret Value
    tenant: 'common', // Tenant ID o 'common' para multi-tenant
    scope: 'openid profile email', // Permisos que solicitas
    redirectUri: 'https://allasenlinea.com:777', // URI de redirección
  },
};
